import { env } from "@/config/env";
import { createHttpClient } from "./client";
import { createMockClient } from "./mockClient";
import type { IntakeApi } from "./types";

let cached: IntakeApi | null = null;

/** Resolve the active API client (mock or real) based on env config. */
export function getApi(apiBaseUrl: string = env.apiBaseUrl): IntakeApi {
  if (cached) return cached;
  cached = env.useMockApi ? createMockClient() : createHttpClient(apiBaseUrl);
  return cached;
}

export type { IntakeApi } from "./types";
